/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventResponseRecordsInnerDefinition
 */
export interface EventResponseRecordsInnerDefinition {
    /**
     * 
     * @type {string}
     * @memberof EventResponseRecordsInnerDefinition
     */
    id?: string;
}

/**
 * Check if a given object implements the EventResponseRecordsInnerDefinition interface.
 */
export function instanceOfEventResponseRecordsInnerDefinition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventResponseRecordsInnerDefinitionFromJSON(json: any): EventResponseRecordsInnerDefinition {
    return EventResponseRecordsInnerDefinitionFromJSONTyped(json, false);
}

export function EventResponseRecordsInnerDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventResponseRecordsInnerDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function EventResponseRecordsInnerDefinitionToJSON(value?: EventResponseRecordsInnerDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

